/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import SignatureCards from '../signature/SignatureCards';

const useStyles = makeStyles(() => ({
  preview: {
    height: '100vh',
  },
  grid: {},
}));

export default function SubmissionPreviewCanvas({ className, submission, previewObject }) {
  const classes = useStyles();

  if (previewObject?.id === 'signature') {
    return (
      <div className={clsx(className)}>
        <SignatureCards readOnly submission={submission} />
      </div>
    );
  }

  if (['application/xml', 'text/xml'].includes(previewObject?.type)) {
    return (
      <div className={className}>
        <figure>
          <pre>{previewObject?.path}</pre>
        </figure>
      </div>
    );
  }

  if (['image/jpeg'].includes(previewObject?.type)) {
    return (
      <div className={className}>
        <img
          aria-label={`File on Preview with user reference: ${submission?.basicFilingInfo?.userReference}`}
          src={previewObject.path}
          alt="jpeg"
          width="100%"
          height="100%"
          className={classes.preview}
        />
      </div>
    );
  }

  return (
    <div className={className}>
      <embed
        id="filePreview"
        aria-label={`File on Preview with user reference: ${submission?.basicFilingInfo?.userReference}`}
        src={previewObject?.path}
        type="application/pdf"
        alt="pdf"
        width="100%"
        height="100%"
        className={classes.preview}
      />
    </div>
  );
}
